import React,{ Component } from 'react';
import {Row, Col, Button, ButtonGroup} from 'react-bootstrap';
import SelectWrap from '../../../../components/SelectWrap';
import { handleFieldChange } from "../../../../Utils";
import countries from "../../../../data/countries";
import FieldGroup from "../../../../components/FieldGroup";

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            country: null,
            word: null,
            minCPC: null
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }


    handleFormSubmit() {
        const filters = Object.assign({}, this.state);

        this.props.onSubmit(filters);
    }

    render() {
        return (
            <form>
                <Row>
                    <Col lg={3}>
                        <SelectWrap
                            values={countries}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                        />
                    </Col>
                    <Col lg={3}>
                        <FieldGroup
                            name="word"
                            label="Word:"
                            onChange={this.handleFieldChange}
                            value={this.state.word}
                        />
                    </Col>
                    <Col lg={3}>
                        <FieldGroup
                            type={'number'}
                            name="minCPC"
                            label="Min. CPC:"
                            onChange={this.handleFieldChange}
                            value={this.state.minCPC}
                        />
                    </Col>
                </Row>

                <ButtonGroup>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={this.handleFormSubmit}>Load</Button>
                </ButtonGroup>
            </form>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/scenes/BidderSpy/components/Form/index.js